<template>
  <div class="activities-container">
    <p class="title">
      决战港股
      <br> 格隆汇海外投资嘉年华系列峰会

    </p>
    <p style="text-align:center;padding:20px;">
      报名城市-->{{cityName}}
    </p>
    <div class="form">
      <p>
        <label class="formLabel">公司
          <span style="color:red">*</span>
        </label>
        <input type="text" placeholder="请输入公司名称" class="formInput" v-model="companyName">
      </p>
      <p>
        <label class="formLabel">姓名
          <span style="color:red">*</span>
        </label>
        <input type="text" placeholder="请输入您的姓名" class="formInput" v-model="username">
      </p>
      <p>
        <label class="formLabel">职位
          <span style="color:red">*</span>
        </label>
        <input type="text" placeholder="请输入您的职位" class="formInput" v-model="job">
      </p>
      <p>
        <label class="formLabel">Email
          <span style="color:red">*</span>
        </label>
        <input type="text" placeholder="请输入您的Email" class="formInput" v-model="email">
      </p>
      <p>
        <label class="formLabel">手机
          <span style="color:red">*</span>
        </label>
        <input type="text" placeholder="请输入您的手机号码" class="formInput" v-model="phone">
      </p>
      <p>
        <label class="formLabel">微信</label>
        <input type="text" placeholder="请输入您的微信" class="formInput" v-model="wechat">
      </p>

      <p style="text-indent: 15px;" class="ptimes">场次
        <span style="color:red">*</span>
      </p>
      <span class="radioPlay" v-for="(item,index) in times" :class="play == item?'blue':''">
        <label>
          <input type="radio" v-model="play" :value="item" style="display:none" name="play"> {{item}}
        </label>
      </span>


      <mt-button size="large" class="submit" @click="submit()">提交</mt-button>
    </div>

    <div class="footer"></div>

  </div>
</template>
<script>
  import {
    Toast
  } from 'mint-ui';
  export default {
    name: 'activity',
    data() {
      return {
        cityName: '广州',
        companyName: '',
        username: '',
        job: '',
        email: '',
        phone: '',
        wechat: '',
        play: '',
        times: ['13:30-14:10(已满)', '14:10-15:30', '14:50-15:30', '15:45-16:25', '16:25-17:05', '17:05-17:45']
      }
    },
    methods: {
      submit() {
        var regEmail = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        var regPhone = /^1(3|4|5|7|8)\d{9}$/;
        if (!this.companyName || !this.username || !this.job || !this.email || !this.phone) {
          Toast({
            message: '请填写完整的信息',
            position: 'top',
            duration: 5000
          });
          return false;
        }
        if (!regEmail.test(this.email)) {
          Toast({
            message: '请填写正确的邮箱地址',
            position: 'top',
            duration: 5000
          });
          return false;
        }

        if (!regPhone.test(this.phone)) {
          Toast({
            message: '请填写正确的手机号码',
            position: 'top',
            duration: 5000
          });
          return false;
        }
      },
      getData(city) {
        this.$http.hkstocks_query(city).then(res => {
          console.log(res.data)
        })
      }
    },
    mounted() {
      this.getData('深圳')
    }
  }

</script>
<style scpoed>
  .title-off {
    width: 100%;
    padding: 10px 0;
    background: #AB3B2D;
    text-align: center;
    font-size: 20px;
    line-height: 30px;
    font-weight: bold;
    color: #fff;
  }

  .blue {
    background: #AB3B2D !important;
    color: #fff !important;
  }

  .form {
    padding: 0 10px 20px 10px;
  }

  .form p {
    margin: 0;
    padding: 0;
    height: 45px;
    border-top: 1px solid #cfcfcf
  }

  .form .formLabel {
    margin: 0;
    padding: 0;
    width: 30%;
    text-indent: 15px;
    display: inline-block
  }

  .form .formInput {
    width: 60%;
    height: 45px;
    border: none;
    outline: none;
  }

  .ptimes {
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
  }

  .radioPlay {
    display: inline-block;
    width: 45%;
    margin: 10px 3% 0 1%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #656b79;
    background-color: #f6f8fa;
    box-shadow: 0 0 1px #b8bbbf
  }

  .submit {
    margin-top: 20px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #fff;
    background: #AB3B2D;
  }

  .footer {
    width: 100%;
    height: 70px;
    background: #AB3B2D;
  }

</style>



// WEBPACK FOOTER //
// src/components/frontend/index.vue